module.exports = __webpack_public_path__ + "files/02525f7d989933daf56d353053273db4.png";